export const messages = {
  en: {
    itemReleaseManage: {
      search: {
        title: 'Search Conditions',
        more: 'More',
        hide: 'Hide'
      },
      list: {
        title: 'Item Release'
      },
      form: {
        releaseType: 'Release Type',
        applyCompany: 'Apply Company',
        applyPerson: 'Applicant',
        idCard: 'ID Card',
        phone: 'Phone',
        passTime: 'Pass Time',
        releaseItems: 'Release Items',
        itemAmount: 'Item Amount',
        status: 'Status',
        carNumber: 'Car Number',
        remark: 'Remark'
      },
      table: {
        orderNo: 'Order No',
        releaseType: 'Release Type',
        applyCompany: 'Apply Company',
        applyPerson: 'Applicant',
        idCard: 'ID Card',
        phone: 'Phone',
        passTime: 'Pass Time',
        items: 'Items',
        status: 'Status',
        carNumber: 'Car Number'
      },
      button: {
        applyRelease: 'Apply Release',
        viewItems: 'View Items'
      },
      placeholder: {
        selectReleaseType: 'Please select release type',
        selectApplyCompany: 'Please select apply company',
        selectApplyPerson: 'Please select applicant',
        selectIdCard: 'Please input ID card',
        selectPhone: 'Please input phone',
        selectStatus: 'Please select status',
        requiredSelect: 'Required, please select',
        requiredInput: 'Required, please input',
        optionalInput: 'Optional, please input'
      },
      status: {
        waiting: 'Waiting',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed'
      },
      validate: {
        required: 'Cannot be empty',
        maxLength30: 'Cannot exceed 30 characters',
        maxLength64: 'Cannot exceed 64 characters',
        maxLength18: 'Cannot exceed 18 characters',
        maxLength11: 'Cannot exceed 11 characters',
        maxLength12: 'Cannot exceed 12 characters',
        maxLength512: 'Cannot exceed 512 characters'
      },
      edit: {
        title: 'Edit Item Release'
      },
      delete: {
        confirmDelete: 'Confirm to delete item release?'
      },
      viewItems: {
        title: 'Release Items',
        itemName: 'Item Name',
        amount: 'Amount'
      }
    }
  },
  zh: {
    itemReleaseManage: {
      search: {
        title: '查询条件',
        more: '更多',
        hide: '隐藏'
      },
      list: {
        title: '物品放行'
      },
      form: {
        releaseType: '放行类型',
        applyCompany: '申请单位',
        applyPerson: '申请人',
        idCard: '身份证',
        phone: '手机号',
        passTime: '通行时间',
        releaseItems: '放行物品',
        itemAmount: '物品数量',
        status: '状态',
        carNumber: '车牌号',
        remark: '备注'
      },
      table: {
        orderNo: '单号',
        releaseType: '放行类型',
        applyCompany: '申请单位',
        applyPerson: '申请人',
        idCard: '身份证',
        phone: '手机号',
        passTime: '通行时间',
        items: '物品',
        status: '状态',
        carNumber: '车牌号'
      },
      button: {
        applyRelease: '申请放行',
        viewItems: '查看物品'
      },
      placeholder: {
        selectReleaseType: '请选择放行类型',
        selectApplyCompany: '请选择申请单位',
        selectApplyPerson: '请选择申请人',
        selectIdCard: '请输入身份证',
        selectPhone: '请输入手机号',
        selectStatus: '请选择状态',
        requiredSelect: '必填，请选择',
        requiredInput: '必填，请输入',
        optionalInput: '选填，请输入'
      },
      status: {
        waiting: '待审核',
        processing: '审核中',
        completed: '审核完成',
        failed: '审核失败'
      },
      validate: {
        required: '不能为空',
        maxLength30: '不能超过30个字符',
        maxLength64: '不能超过64个字符',
        maxLength18: '不能超过18个字符',
        maxLength11: '不能超过11个字符',
        maxLength12: '不能超过12个字符',
        maxLength512: '不能超过512个字符'
      },
      edit: {
        title: '修改物品放行'
      },
      delete: {
        confirmDelete: '确定删除物品放行?'
      },
      viewItems: {
        title: '放行物品',
        itemName: '物品名称',
amount: '数量'
      }
    }
  },
  'zh-TW': {
    itemReleaseManage: {
      search: {
        title: '查詢條件',
        more: '更多',
        hide: '隱藏'
      },
      list: {
        title: '物品放行'
      },
      form: {
        releaseType: '放行類型',
        applyCompany: '申請單位',
        applyPerson: '申請人',
        idCard: '身份證',
        phone: '手機號',
        passTime: '通行時間',
        releaseItems: '放行物品',
        itemAmount: '物品數量',
        status: '狀態',
        carNumber: '車牌號',
        remark: '備註'
      },
      table: {
        orderNo: '單號',
        releaseType: '放行類型',
        applyCompany: '申請單位',
        applyPerson: '申請人',
        idCard: '身份證',
        phone: '手機號',
        passTime: '通行時間',
        items: '物品',
        status: '狀態',
        carNumber: '車牌號'
      },
      button: {
        applyRelease: '申請放行',
        viewItems: '查看物品'
      },
      placeholder: {
        selectReleaseType: '請選擇放行類型',
        selectApplyCompany: '請選擇申請單位',
        selectApplyPerson: '請選擇申請人',
        selectIdCard: '請輸入身份證',
        selectPhone: '請輸入手機號',
        selectStatus: '請選擇狀態',
        requiredSelect: '必填，請選擇',
        requiredInput: '必填，請輸入',
        optionalInput: '選填，請輸入'
      },
      status: {
        waiting: '待審核',
        processing: '審核中',
        completed: '審核完成',
        failed: '審核失敗'
      },
      validate: {
        required: '不能為空',
        maxLength30: '不能超過30個字符',
        maxLength64: '不能超過64個字符',
        maxLength18: '不能超過18個字符',
        maxLength11: '不能超過11個字符',
        maxLength12: '不能超過12個字符',
        maxLength512: '不能超過512個字符'
      },
      edit: {
        title: '修改物品放行'
      },
      delete: {
        confirmDelete: '確定刪除物品放行?'
      },
      viewItems: {
        title: '放行物品',
        itemName: '物品名稱',
        amount: '數量'
      }
    }
  }
}